import React from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub } from 'react-icons/fa';

const Profile = () => (
  <div className="flex flex-col pb-4 w-full space-y-4 dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl relative backdrop-blur-sm mb-10 z-20 items-center md:items-start pr-3 md:mb-0">

    {/* Centered Profile Image */}
    <div className="flex justify-center w-full mb-4">
      <img src="/mina.jpg" alt="Profile" className="w-32 h-32 skeleton floatAnimation rounded-full" />
    </div>

    {/* Centered Button */}
    <div className="flex justify-center w-full">
      <button
       className="flex items-center space-x-2 p-2 bg-inherit border-white border-4 text-gray-200 rounded-lg shadow-md dark:bg-gray-700 dark:text-white hover:-translate-y-1 transition-all duration-1000"
        onClick={() => window.location.href = 'mailto:imina3951@gmail.com'}>
        Send Email
      </button>
    </div>

    {/* Text Information Aligned to the Left */}
    <div className="w-full">
      <p className="flex text-gray-200 items-center select-text">
        <FaEnvelope className="mr-2" />
        <strong className='mr-2'>Email:</strong> imina3951@gmail.com
      </p>
      <p className="flex items-center text-gray-200 select-text">
        <FaPhone className="mr-2" />
        <strong className='mr-2'>Phone:</strong> (+20) 01273369866
      </p>
      <p className="flex items-center text-gray-200 select-text">
        <FaMapMarkerAlt className="mr-2" />
        <strong className='mr-2'>Location:</strong> Cairo, Egypt
      </p>
      <p className="flex items-center text-gray-200 select-text">
        <FaGithub className="mr-2" />
        <strong className="mr-2">GitHub:</strong>
        <a href="https://github.com/minaa66/" className="text-green-300 dark:text-blue-300 hover:underline">GitHub Profile</a>
      </p>
    </div>
  </div>
);

export default Profile;
